import TCTable from './component/table/index.vue';
import TcTableSelectedRowsField from './component/table/selected-rows-field.vue';
import TCDateTimeInput from './component/datetime-input/index.vue';
import TCTabsProxy from './component/tabs/proxy.vue';
import TCLazyModelChoiceField from './component/tc-lazy-model-choice-field/index.vue';
var TrackingCloud = /** @class */ (function () {
    function TrackingCloud() {
    }
    TrackingCloud.install = function (Vue, options) {
        Vue.component('tc-table', TCTable);
        Vue.component('tc-table-selected-rows-field', TcTableSelectedRowsField);
        Vue.component('tc-datetime-input', TCDateTimeInput);
        Vue.component('tc-lmc', TCLazyModelChoiceField);
        Vue.component('tc-tabs', TCTabsProxy);
    };
    return TrackingCloud;
}());
export default TrackingCloud;
